import moment from 'moment';
import {
    EBFL1RecordCode,
    EBFL1RecordState,
    TBFL1BackendRecord,
    TBFL1CommonData,
    TBFL1CommonFields,
} from '../@types';
import { EMARPOLDocuments } from '../../marpol/@types';
import MARPOLModule from '../../marpol/operation.types';

export type TBFL1D1 = TBFL1CommonFields &
    TBFL1CommonData & {
        recordCode: EBFL1RecordCode.BFL1D1;
    };

export type TBFL1ItemD2 = MARPOLModule.MissedEntryItem<TBFL1BackendRecord>;

export type TBFL1D2 = TBFL1CommonFields &
    TBFL1CommonData & {
        recordCode: EBFL1RecordCode.BFL1D2;
        itemD2: TBFL1ItemD2;
    };
export type TBFL1GroupD = TBFL1D1 | TBFL1D2;

const BFL1_GROUPD_DEFAULTS: {
    D1: TBFL1D1;
    D2: TBFL1D2;
} = {
    D1: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.BFL1,
        state: EBFL1RecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        recordCode: EBFL1RecordCode.BFL1D1,
        processedTanks: [],
    },
    D2: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.BFL1,
        state: EBFL1RecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        recordCode: EBFL1RecordCode.BFL1D2,
        processedTanks: [],
        itemD2: {
            dateOfOriginalOperation: '',
            isAnMissedEntryRecord: true,
            missedRecord: undefined,
            receiptAttachment: ' ',
        },
    },
};

export { BFL1_GROUPD_DEFAULTS };
